import { studioAddOrUpdateDesign } from 'redux/Studio';
import warehouse from 'services/warehouse';
import { bugsnagError } from 'services/bugsnag';

import { HIDE_MOBILE_BANNER } from './action-constants';

export const hideMobileBanner = () => ({
  type: HIDE_MOBILE_BANNER
});

const updateDesignFeedbackThisSession = ({ design, userFeedback }) => dispatch => {
  const newDesign = design.makeCopy({ userFeedback });
  dispatch(studioAddOrUpdateDesign(newDesign));
};

export const updateDesignRating = ({ design, rating, sessionOnly = false }) => dispatch => {
  const userFeedback = { rating };
  return dispatch(submitDesignFeedback({ design, userFeedback, sessionOnly }));
};

export const submitDesignFeedback = ({ design, userFeedback, sessionOnly = false }) => dispatch => {
  let data = {};
  if (design.userFeedbackId()) { data.id = design.userFeedbackId(); }
  if (userFeedback.rating) { data.rating = userFeedback.rating; }
  if (userFeedback.areas) {
    if (userFeedback.areas.includes('Address My Notes')) { data.address_my_notes = true; }
    if (userFeedback.areas.includes('Color Choices')) { data.color_choices = true; }
    if (userFeedback.areas.includes('Furniture Layout')) { data.furniture_layout = true; }
    if (userFeedback.areas.includes('Product Selection')) { data.product_selection = true; }
    if (userFeedback.areas.includes('Style Match')) { data.style_match = true; }
    if (userFeedback.areas.includes('3D Room Model')) { data.three_d_room_model = true; }
  }

  // Always update redux state.
  dispatch(updateDesignFeedbackThisSession({ design, userFeedback: data }));
  // Don't send feedback to API if session only
  if (sessionOnly) return;
  // Make backend API call to warehouse so we can study the feedback
  // and also not ask for feedback again in future sessions.
  // But ignore any submission errors as we do not want to interrupt user workflow here.
  return warehouse.submitDesignFeedbackV2({ design, userFeedback: data })
    .then(response => {
      if (!design.userFeedbackId()) {
        data.id = response.id;
        dispatch(updateDesignFeedbackThisSession({ design, userFeedback: data }));
      }
    })
    .catch(error => {
      bugsnagError(error);
    });
};
